<template>
  <a-layout-sider
    :class="[theme, 'sider', isMobile ? null : 'shadow', fixSiderbar? 'ant-fixed-sidemenu' : null]"
    width="256px"
    :collapsible="collapsible"
    v-model="collapsed"
    :trigger="null">
    <div :class="['logo',{min:collapsed}, theme]"> 
      <router-link to="/">
        <img :src="logoIcon" alt="">
        <span :class="['sys-title','animated','fadeIn',{isShow:collapsed}]">{{systemName}}</span>
      </router-link>
    </div >
    <menu-bar :theme="theme" :collapsed="collapsed" :menuData="menuData" @select="onSelect"/>
    <!-- <i-menu :theme="theme" :collapsed="collapsed" :menuData="menuData" @select="onSelect"/> -->
  </a-layout-sider>
</template>

<script>
// import IMenu from './menu'
import MenuBar from './MenuBar'
import { mapState } from 'vuex'

export default {
  name: 'SiderMenu',
  components: {
    // IMenu,
    MenuBar
    },
  props: {
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menuData: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.setting.isMobile,
      systemName: state => state.setting.systemName,
      fixSiderbar: state => state.setting.fixSiderbar
    }),
    logoIcon(){
      return this.theme == 'light'?require('../../../static/img/ranqi_logo_red.png'):require('../../../static/img/logo1.png')
    }
  },
  methods: {
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    }
  },
  
}
</script>

<style lang="less" scoped>
  .isShow{
     visibility: hidden;
  }
  .shadow {
    box-shadow: 1px 0 6px rgba(0, 21, 41, .35);
  }
  .sider {
    z-index: 16;
    position: relative;
    padding-bottom: 120px;
    overflow-x: hidden;
    &.light {
      background-color: #fff;
    }
    &.dark {
      background-color: #393e46;
    }
    &.ant-fixed-sidemenu {
      position: fixed;
      overflow-y: auto;
      height: 100%;
    }
    .logo {
      height: 59px;
      position: relative;
      line-height: 59px;
      padding-left: 18px;
      -webkit-transition: all .3s;
      transition: all .3s;
      overflow: hidden;
      &.min{
        padding-left: 24px;
      }
      &.light {
        // background-color: #fff;
        background-color:#004290;
        // border-bottom: 1px solid #f8f8f8;
        .sys-title {
          color: #fff;
        }
      }
      &.dark {
        background-color: #393e46;
        .sys-title {
          color: #fff;
        }
      }
      .sys-title {
        color: #fff;
        font-size: 18px;
        margin: 0 0 0 0px;
        font-family: Chinese Quote,-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
        font-weight: 600;
        display: inline-block;
        height: 32px;
        line-height: 32px;
        vertical-align: middle;
      }
      img {
        width: 32px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/SiderMenu.vue